import { render, staticRenderFns } from "./JobNewMore.vue?vue&type=template&id=13555dfa&"
import script from "./JobNewMore.vue?vue&type=script&lang=js&"
export * from "./JobNewMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports